
import state from './moduleClientsManagementState'
import mutations from './moduleClientsManagementMutations'
import actions from './moduleClientsManagementActions'
import getters from './moduleClientsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

